<template>
  <el-dialog
    title="预设列表"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="1000px"
  >
    <div class="dialog_box">
      <div class="page_option_box">
        <div class="option_box">
          <input
            type="file"
            id="xlsFile"
            accept=".xls,.xlsx"
            @change="importData($event)"
          />
          <el-button
            type="primary"
            plain
            size="mini"
            @click="selectFileImport()"
            >导入</el-button
          >
          <el-button
            size="mini"
            type="primary"
            plain
            @click="del"
            :disabled="ids.length > 0 ? false : true"
          >
            删除
          </el-button>
        </div>
        <div class="search_box">
          <el-select
            size="mini"
            v-model="reqData.announcementDataType"
            placeholder="请选择告知类型"
            @change="getList"
          >
            <el-option label="告知卡" :value="1"> </el-option>
            <el-option label="告知栏" :value="2"> </el-option>
            <el-option label="重大风险公告栏" :value="3"> </el-option>
          </el-select>
          <!-- <el-button
            type="primary"
            size="mini"
            plain
            icon="el-icon-search"
            @click="getList"
            >搜索</el-button
          > -->
          <!-- <div class="search_icon_box button-box" @click="getList()">
            <div></div>
            <span>搜索</span>
          </div> -->
        </div>
      </div>
      <div class="page_table_box">
        <div class="school_table_box" style="height: 500px">
          <el-table
            :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
            :data="resData.list"
            height="100%"
            class="table_box"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50" align="center">
            </el-table-column>
            <el-table-column label="序号" width="70" align="center">
              <template v-slot="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="announcementDataName"
              label="名称"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="announcementDataType"
              label="预设类型"
              align="center"
              show-overflow-tooltip
            >
              <template v-slot="scope">
                <div v-if="scope.row.announcementDataType == 1">告知卡</div>
                <div v-if="scope.row.announcementDataType == 2">告知栏</div>
                <div v-if="scope.row.announcementDataType == 3">
                  重大风险公告栏
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="reqData.announcementDataType == 3"
              prop="announcementDataGrade"
              label="风险等级"
              align="center"
              show-overflow-tooltip
            >
              <template v-slot="scope">
                <div v-if="scope.row.announcementDataGrade == 1">一级</div>
                <div v-if="scope.row.announcementDataGrade == 2">二级</div>
                <div v-if="scope.row.announcementDataGrade == 3">三级</div>
                <div v-if="scope.row.announcementDataGrade == 4">四级</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="riskFactor"
              :label="
                reqData.announcementDataType == 2
                  ? '易发生事故类型'
                  : '风险因素'
              "
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="typeAccident"
              :label="
                reqData.announcementDataType == 1
                  ? '风险类别'
                  : reqData.announcementDataType == 2
                  ? '主要风险因素'
                  : '可能导致的事故类型'
              "
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="controlMeasures"
              label="管控措施"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="emergencyMeasures"
              label="应急措施"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template v-slot="scope">
                <el-link
                  type="primary"
                  @click="edit(scope.row)"
                  :underline="false"
                  >编辑</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-link
                  type="primary"
                  @click="del(scope.row.announcementDataId)"
                  :underline="false"
                  >删除</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="pagination_box" style="padding-top:20px">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page="resData.pageNum"
            :page-sizes="[20, 50, 100, 200]"
            :page-size="reqData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="resData.total"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
    <default-detail
      :resize="detailResize"
      :detail="detail"
      @getList="getList"
    ></default-detail>
  </el-dialog>
</template>

<script>
import defaultDetail from "./RiskNoticeTemplateDefaultDetail.vue";
export default {
  name: "RiskNoticeTemplateDefault",
  components: {
    defaultDetail
  },
  props: {
    resize: {
      type: Number,
      default: {
        return: 0
      }
    },
    templateType: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    //这里存放数据
    return {
      fileUrl: this.$store.state.config.fileUrl,
      showDialog: false,
      showState: 0,
      reqData: {
        announcementDataType: 0
      },
      resData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      ids: [],
      detailResize: 0,
      detail: {}
    };
  },
  //监控data中的数据变化
  watch: {
    resize: function(val) {
      if (val) {
        this.reqData.announcementDataType = this.templateType;
        this.getList();
        this.showDialog = true;
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    handleClose() {
      this.clearData();
      this.showDialog = false;
    },
    handleCurrentChange(val) {
      this.reqData.pageNum = val;
      this.getList();
      this.ids = [];
    },
    handleSelectionChange(val) {
      this.ids = val.map((item) => {
        return item.announcementDataId;
      });
    },
    clearData() {
      this.ids = [];
    },
    selectFileImport() {
      document.getElementById("xlsFile").click();
    },
    edit(item) {
      this.detail = item;
      this.detailResize++;
    },
    del(id = 0) {
      this.$confirm("此操作将永久删除该预设, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (id > 0) {
            this.delDefault([id]);
          } else {
            this.delDefault(this.ids);
          }
        })
        .catch(() => {});
    },
    submit() {
      if (this.ids.length > 0) {
        this.showState = 1;
        this.addProtectActivityPolice(this.ids);
      } else {
        this.$message("请选择要添加的民警！");
      }
    },
    async getList() {
      let req = this.reqData;
      let res = await this.$Http.getNoticeTemplateDefault(req);
      if (res.code == 200) {
        this.resData.list = res.data || [];
      } else if (res.code == 101) {
        this.resData.list = [];
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    // 导入数据
    async importData() {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "数据导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let req = {
        file: fileUpload
      };
      document.getElementById("xlsFile").value = null;
      let res = await this.$Http.importNoticeTemplateDefault(req, true);

      // console.log(res)

      loading.close();
      if (res&&res.code == 200) {
        this.$message({
          type: "success",
          message: "导入成功"
        });
        this.getList();
      } else if (res&&res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res&&res.messsage
        });
      }
    },

    async delDefault(ids) {
      let req = {
        announcementDataIdList: ids
      };
      let res = await this.$Http.delNoticeTemplateDefault(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.el-dialog {
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
}
.edu_pages_content_body_box {
  margin: 0;
  padding: 0;
}
.dialog-footer {
  text-align: right;
}
</style>
